import React, { useState } from "react";
import SEO from "components/SEO";
import tw from "twin.macro";
import MapSection from "./MapSection";
import FacultyDawahSection from "./FacultyDawah";
import Faculty from "./Faculty";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import SingleCol from "components/faqs/SingleCol.js";
// adj
import Layout from "components/layouts/Layout";
// Page-level structural wrappers for consistent spacing & layout
const PageSection = tw.section`w-full py-1 lg:py-2`;
const SectionInner = tw.div`max-w-screen-xl mx-auto px-6 lg:px-8 bg-white`;
const SectionHeader = tw.div`mb-2 lg:mb-2`;
const SectionTitle = tw.h2`text-3xl lg:text-4xl font-bold text-gray-900`;

export default () => {
  const [hasFacultyContent, setHasFacultyContent] = useState(true);
  const [hasDawahContent, setHasDawahContent] = useState(true);

  return (
    <Layout>
      <SEO title="About Us" description="Learn about Jamia Mohammadia Arabia — its mission, faculty, and Islamic educational heritage in Rayadurg, Andhra Pradesh." path="/about" />
      <PageSection>
        <SectionInner>
          <SectionHeader></SectionHeader>
          <SingleCol />
        </SectionInner>
      </PageSection>

      {/* Faculty - Conditionally rendered */}
      {hasFacultyContent && (
        <PageSection>
          <SectionInner>
            <SectionHeader></SectionHeader>
            <Faculty onNoContent={() => setHasFacultyContent(false)} />
          </SectionInner>
        </PageSection>
      )}

      {/* Dawah & Outreach - Conditionally rendered */}
      {hasDawahContent && (
        <PageSection>
          <SectionInner>
            <SectionHeader></SectionHeader>
            <FacultyDawahSection
              onNoContent={() => setHasDawahContent(false)}
            />
          </SectionInner>
        </PageSection>
      )}

      {/* Location */}
      <PageSection>
        <SectionInner>
          <SectionHeader>
            <SectionTitle>Our Location</SectionTitle>
          </SectionHeader>
          <MapSection />
        </SectionInner>
      </PageSection>
    </Layout>
  );
};
